/**
 * @prop --max-height: Maximum height of table
 * @prop --min-width: Minium width of table
 * @prop --cell-padding: Cells padding
 * @prop --search-input-width: Search input width from small breakpoint

 * @prop --stzh-table-max-width: **Global**: Maximum height of table
 * @prop --stzh-table-min-width: **Global**: Minium width of table
 * @prop --stzh-table-cell-padding: **Global**: Cells padding
 * @prop --stzh-table-search-input-width: **Global**: Search input width from small breakpoint
 */

stzh-table {
  @include host;
  @include table-host();
}

.stzh-table {
  @include table("table");

  &.has-scroll-right &__wrapper {
    overflow-x: scroll;
  }
}
